import { render, staticRenderFns } from "./OrderServiceInfo.vue?vue&type=template&id=db7a1f6a&"
import script from "./OrderServiceInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderServiceInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports